import { Store } from 'vuex'
import { State as StoreState } from '@/store/index'
import * as StateType from '@/store/state'
import ACTION_TYPE from '@/store/actionTypes'
import * as Screen from '@/store/stateScreen'
import { MENU_TYPE } from '@/model/components/menu/sideMenuType'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'

/**
 * vuexのアクション処理を実施する
 * @param store vuex
 */
const useStoreAction = (store: Store<StoreState>) => {
  /**
   * vuexに初期状態(非ログイン)に設定する
   */
  const init = async () => {
    await store.dispatch(ACTION_TYPE.LOGOUT)
  }
  /**
   * vuexに認証情報を設定する
   * @param input 入力データ
   */
  const loginAuthinfo = async (input: StateType.Login) => {
    await store.dispatch(ACTION_TYPE.LOGIN_AUTH, input)
  }
  /**
   * vuexにTOP画面遷移情報を設定する
   * @param input 入力データ
   */
  const topRedirect = async (input: Screen.Top) => {
    await store.dispatch(ACTION_TYPE.TOP_REDIRECT, input)
  }
  /**
   * vuexにログイン情報を設定する
   */
  const login = async () => {
    await store.dispatch(ACTION_TYPE.LOGIN_INFO)
  }
  /**
   * vuexにログイン前初期情報を設定する
   */
  const loginBefore = async () => {
    await store.dispatch(ACTION_TYPE.LOGIN_BEFORE_INIT)
  }
  /**
   * vuexにメニュー情報を設定する
   * @param input 入力データ
   */
  const menu = async (input: MENU_TYPE) => {
    await store.dispatch(ACTION_TYPE.MENU_SET, input)
  }
  /**
   * vuexにダウンロード検索情報を設定する
   * @param input 入力データ
   */
  const downloadDetail = async (input: Screen.DonwloadDetail) => {
    await store.dispatch(ACTION_TYPE.DOWNLOAD_SET, input)
  }
  /**
   * vuexにダウンロード検索情報を初期化する
   */
  const downloadDetailInit = async () => {
    await store.dispatch(ACTION_TYPE.DOWNLOAD_CLEAR)
  }
  /**
   * vuexにダウンロードエラー情報を設定する
   * @param input 入力データ
   */
  const downloadError = async (input: ErrorMsgState) => {
    await store.dispatch(ACTION_TYPE.DOWNLOAD_ERROR_SET, input)
  }
  /**
   * 言語切り替えを実施する
   * @param input 入力データ
   */
  const changeLang = async (input: string) => {
    await store.dispatch(ACTION_TYPE.LANGCHANGE_SET, input)
  }
  /**
   * ヘッダー表示情報を初期化する
   */
  const headerInit = async () => {
    await store.dispatch(ACTION_TYPE.HEADER_CLEAR)
  }

  /**
   * 他画面情報の設定
   */
  const otherInit = async () => {
    await store.dispatch(ACTION_TYPE.OTHER_SET)
  }

  return {
    init,
    loginAuthinfo,
    topRedirect,
    login,
    loginBefore,
    menu,
    downloadDetail,
    downloadDetailInit,
    downloadError,
    changeLang,
    headerInit,
    otherInit,
  }
}

export { useStoreAction }
